import { responseError } from 'FIELDS';

const withNotificationForError = (payloadCreator) => {
  return async (args, thunkAPI) => {
    try {
      return await payloadCreator(args, thunkAPI);
    } catch (error) {
      responseError(error);
      throw error;
    }
  };
};

const checkPermissions = (menuItems, acl, user) => {
  const filtered = menuItems
    .filter((item) => !item.permissions || item.permissions.some((permission) => acl.includes(permission)))
    .map((item) => {
      const newItem = { ...item };

      if (newItem.subItems) {
        newItem.subItems = checkPermissions(newItem.subItems, acl, user);
      }

      return newItem;
    });

  return filtered.filter((item) => !item.subItems || item.subItems.length > 0);
};

export { withNotificationForError, checkPermissions };
